import React from 'react';
import { Typography, Tag } from 'antd';
import { DebugEntry } from '../../types/chat.types';
import './Chat.css';

const { Text } = Typography;

interface DebugPanelProps {
  entries: DebugEntry[];
}

const DebugPanel: React.FC<DebugPanelProps> = ({ entries }) => {
  const formatTime = (date: Date) => {
    return new Date(date).toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  const getTagColor = (type: DebugEntry['type']): string => {
    switch (type) {
      case 'request':
        return 'blue';
      case 'response':
        return 'green';
      case 'error':
        return 'red';
    }
  };

  const getTagLabel = (type: DebugEntry['type']): string => {
    switch (type) {
      case 'request':
        return 'REQUEST';
      case 'response':
        return 'RESPONSE';
      case 'error':
        return 'ERROR';
    }
  };

  return (
    <div className="debug-panel">
      <div className="debug-panel-header">
        <Text strong style={{ color: '#fff' }}>
          Debug / Monitor
        </Text>
      </div>
      <div className="debug-panel-content">
        {entries.length === 0 && (
          <div className="debug-panel-empty">
            <Text type="secondary">Sin actividad</Text>
          </div>
        )}
        {entries.map((entry, index) => (
          <div key={index} className={`debug-entry ${entry.type}`}>
            <div className="debug-entry-header">
              <Tag color={getTagColor(entry.type)}>{getTagLabel(entry.type)}</Tag>
              <Text type="secondary" style={{ fontSize: 11, color: '#888' }}>
                {formatTime(entry.timestamp)}
              </Text>
            </div>
            <pre className="debug-entry-content">
              {JSON.stringify(entry.data, null, 2)}
            </pre>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DebugPanel;
